export default __webpack_public_path__ + "static/media/mila-banerjee.904707e7.png";